import { useState } from "react";
import { AuditLogDto } from "../types/auditLog";
import { auditLogService } from "../services/auditLogService";
import { useApi } from "./useApi";

export const useAuditLogs = () => {
  // 1. Το GET γίνεται αυτόματα με το useApi, cache, signal και error handling
  const {
    data: auditLogs = [],
    loading: isLoading,
    error,
    refetch: fetchAuditLogs,
  } = useApi<AuditLogDto[]>("audit-logs", (signal) => auditLogService.getAll({}, signal));

  const [modalState, setModalState] = useState<{
    isOpen: boolean;
    title: string;
    message: string;
    type: "success" | "error";
  }>({
    isOpen: false,
    title: "",
    message: "",
    type: "success",
  });

  const closeModal = () => {
    setModalState((prev) => ({ ...prev, isOpen: false }));
  };

  return {
    auditLogs,
    isLoading,
    error,
    fetchAuditLogs: () => fetchAuditLogs(true),
    modalState,
    closeModal,
  };
};